const getDecimalPointIndex = (val: number) => {
  if (val) {
    const decimals = val?.toString()?.split(".")?.[1];

    if (decimals) {
      for (let idx = 0; idx < decimals.length; idx++) {
        if (decimals[idx] !== "0") {
          if(idx < 1){
            return idx + 2
          }
          return idx + 1;
        }
      }
    }
  }
  return 2;
};

export const formatCurrency = (
  value: number,
  currency = "USD",
  locale = "en-US"
) => {
  if (value === undefined || value === null) return "-";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: getDecimalPointIndex(value),
      maximumFractionDigits: getDecimalPointIndex(value),
    }).format(value || 0);
  } catch {
    return String(value);
  }
};
export const formatAmount = (value: string) => {
  if (!value) return "";

  const clean = value.replace(/,/g, "");

  if (isNaN(Number(clean))) return value;

  const [int, dec] = clean.split(".");
  const formattedInt = Number(int).toLocaleString("en-US");

  return dec !== undefined ? `${formattedInt}.${dec}` : formattedInt;
};
export const formatCurrencyDisplay = (value: string | number) => {
  if (value === null || value === undefined || value === "") return "-";

  const numberValue = typeof value === "string" ? Number(value) : value;

  return new Intl.NumberFormat("en-IN", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0, // agar decimals nahi chahiye
  }).format(numberValue);
};
